<template>
  <div class="work-item-list">
    <el-empty v-if="items.length === 0" description="할 일이 없습니다" />

    <div v-for="item in items" :key="item.id" class="work-item-row">
      <el-card shadow="hover" class="work-item-card" :body-style="{ padding: '12px 16px' }">
        <el-row :gutter="8" align="middle">
          <!-- 우선순위 도트 -->
          <el-col :xs="2" :sm="1">
            <div :class="['priority-dot', `priority-${item.priority}`]" />
          </el-col>

          <!-- 유형 태그 -->
          <el-col :xs="6" :sm="3">
            <el-tag :type="taskTypeTag(item.task_type)" size="small">
              {{ item.task_type_display }}
            </el-tag>
          </el-col>

          <!-- 제목 + 브랜드 -->
          <el-col :xs="16" :sm="10" @click="navigateToDetail(item)" class="item-title-col">
            <div class="item-title">{{ item.title }}</div>
            <div v-if="item.brand_name" class="item-sub">{{ item.brand_name }}</div>
          </el-col>

          <!-- D-day -->
          <el-col :xs="12" :sm="4" class="dday-col">
            <span v-if="item.due_date" :class="{ 'text-danger': item.is_overdue }">
              {{ formatDate(item.due_date) }}
              <el-tag
                v-if="item.days_remaining !== null && item.days_remaining !== undefined"
                :type="item.days_remaining < 0 ? 'danger' : item.days_remaining === 0 ? 'warning' : 'info'"
                size="small"
                class="dday-tag"
              >
                {{ item.days_remaining >= 0 ? `D-${item.days_remaining}` : `D+${Math.abs(item.days_remaining)}` }}
              </el-tag>
            </span>
            <span v-else class="text-muted">기한없음</span>
          </el-col>

          <!-- 액션 -->
          <el-col :xs="12" :sm="5" class="action-col">
            <el-button
              v-if="item.status !== 'COMPLETED'"
              type="success"
              size="small"
              @click.stop="$emit('complete', item)"
            >
              완료
            </el-button>
            <el-button size="small" @click.stop="navigateToDetail(item)">
              상세
            </el-button>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

defineProps({
  items: { type: Array, default: () => [] },
})
defineEmits(['complete'])

const router = useRouter()

const taskTypeTag = (type) => {
  const map = {
    MILESTONE: '',
    APPROVAL: 'warning',
    SAMPLE_WORK: 'success',
    MATERIAL_ORDER: 'info',
    CONTRACT_SIGN: 'danger',
  }
  return map[type] || 'info'
}

const formatDate = (date) => {
  if (!date) return ''
  return date.substring(5) // MM-DD
}

const navigateToDetail = (item) => {
  if (item.detail_url) {
    router.push(item.detail_url)
  }
}
</script>

<style scoped>
.work-item-row {
  margin-bottom: 8px;
}

.work-item-card {
  cursor: default;
}

.item-title-col {
  cursor: pointer;
}

.item-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.item-sub {
  font-size: 12px;
  color: #909399;
}

.priority-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 auto;
}

.priority-URGENT { background-color: #F56C6C; }
.priority-HIGH { background-color: #E6A23C; }
.priority-NORMAL { background-color: #409EFF; }
.priority-LOW { background-color: #C0C4CC; }

.dday-col {
  text-align: center;
  font-size: 13px;
}

.dday-tag {
  margin-left: 4px;
}

.action-col {
  text-align: right;
}

.text-danger {
  color: #F56C6C;
  font-weight: 600;
}

.text-muted {
  color: #C0C4CC;
  font-size: 12px;
}
</style>
